import { Component, Prop, Vue } from 'vue-property-decorator';
import submitSuggestionsListMutation from '../../mutations/submitSuggestionsList';
import removeMutation from '../../mutations/removeSuggestion';

import query from '../../queries/suggestionsListSummary';
import SectionTitle from '../shared/sectionTitle.vue';
import SingleMainContainer from '../shared/singleMainContainer.vue';
import SuggestionsListEntries from '../shared/suggestionsListEntries.vue';
import SuggestionsListSideBar from '../shared/suggestionsListSideBar.vue';
import SuggestionsListViewerButtons from './suggestionsListViewerButtons.vue';

@Component({
  components: {
    SuggestionsListSideBar,
    SingleMainContainer,
    SuggestionsListEntries,
    SectionTitle,
    SuggestionsListViewerButtons,
  },
})
export default class SuggestionsListViewer extends Vue {
  @Prop() public suggestionsListId!: string;

  public readonly suggestionsListSummaryQuery = query;

  public get suggestionsListSummaryQueryVariables(): {
    suggestionsListId: string;
  } {
    return {
      suggestionsListId: this.suggestionsListId,
    };
  }

  public async removeSuggestion(suggestion: any): Promise<void> {
    await this.$apollo.mutate({
      mutation: removeMutation,
      variables: {
        suggestionsListId: this.suggestionsListId,
        suggestionId: suggestion.publication.metadata.identifier,
      },
      refetchQueries: [
        {
          query: (this.$refs.entriesComp as any).suggestionsQuery,
          variables: (this.$refs.entriesComp as any).suggestionsQueryVariables,
        },
        {
          query: this.suggestionsListSummaryQuery,
          variables: this.suggestionsListSummaryQueryVariables,
        },
      ],
    });
  }

  public async handleSubmitClick(): Promise<void> {
    const loader = this.$loading.show();
    try {
      await this.$apollo.mutate({
        mutation: submitSuggestionsListMutation,
        variables: {
          suggestionsListId: this.suggestionsListId,
        },
        refetchQueries: [
          {
            query: this.suggestionsListSummaryQuery,
            variables: this.suggestionsListSummaryQueryVariables,
          },
        ],
      });
      Vue.$toast.success(
        this.$t(
          'components.bookshop.suggestions_list_viewer.submission_done'
        ) as string
      );
    } finally {
      loader.hide();
    }
  }
}
